<template>
    <div class="page_search">
        <a-row>
            <a-col :span="12" v-for="searcher_index in [0,1]" :key="searcher_index" class="page_search_col">
                <h3>对比{{searcher_index==0?'一':'二'}}</h3>
                <a-form class="search_form" layout="inline">
                    <a-form-item :label="searcher.type=='server'?null:searcher.label" :validate-status="validations[searcher_index][index].status" :help="validations[searcher_index][index].help"  v-for="(searcher, index) in searchers[searcher_index]" :key="searcher.id">
                        <!-- 日期选择 -->
                        <a-date-picker v-if="searcher.type == 'date'" style="width:210px" :allowClear="false"
                            v-model="vals[searcher_index][index]" :defaultValue="searcher.val" 
                            @change="validations[searcher_index][index]={status:'success', help:null}"/>
                        <!-- 月份选择 -->
                        <a-month-picker v-if="searcher.type == 'month'" style="width:210px" :allowClear="false"
                            v-model="vals[searcher_index][index]" :defaultValue="searcher.val" 
                            @change="validations[searcher_index][index]={status:'success', help:null}"/>
                        <a-range-picker style="width:210px"  :allowClear="false" v-if="searcher.type == 'daterange'" :defaultValue="searcher.val" v-model="vals[searcher_index][index]" @change="validations[searcher_index][index]={status:'success', help:null}"/>
                        <a-radio-group :options="searcher.options" v-if="searcher.type == 'radio'" :defaultValue="searcher.val" v-model="vals[searcher_index][index]" @change="validations[searcher_index][index]={status:'success', help:null}"></a-radio-group>
                        <a-checkbox-group :options="searcher.options" v-if="searcher.type == 'checkbox'" :defaultValue="searcher.val" v-model="vals[searcher_index][index]" @change="validations[searcher_index][index]={status:'success', help:null}"/>
                        <a-select v-if="searcher.type == 'select' && searcher.multiple!=true" style="width: 210px" :defaultValue="searcher.val" v-model="vals[searcher_index][index]" @change="validations[searcher_index][index]={status:'success', help:null}">
                            <template v-for="(option, oindex) in searcher.options">
                                <a-select-opt-group v-if="option.options" :label="option.label" :key="oindex" >
                                    <a-select-option :value="suboption.value" v-for="suboption in option.options" :key="suboption.value">{{suboption.label}}</a-select-option>
                                </a-select-opt-group>
                                <a-select-option :value="option.value" v-if="!(option.options)" :key="oindex">{{option.label}}</a-select-option>
                            </template>
                        </a-select>
                        
                        <a-select mode="multiple" :maxTagCount="5"
                            v-if="searcher.type == 'select' && searcher.multiple==true" style="width: 210px" :defaultValue="searcher.val" v-model="vals[searcher_index][index]" @change="validations[searcher_index][index]={status:'success', help:null}">
                            <div slot="dropdownRender" slot-scope="menu" @mousedown="e=>e.preventDefault()">
                                <v-nodes :vnodes="menu" />
                                <a-divider style="margin: 4px 0;" />
                                <div style="padding: 8px; cursor: pointer;"><a-checkbox @change="selectAll(index, $event)">全选</a-checkbox></div>
                            </div>
                            <template v-for="(option, oindex) in searcher.options">
                                <a-select-opt-group v-if="option.options" :label="option.label" :key="oindex" >
                                    <a-select-option :value="suboption.value" v-for="suboption in option.options" :key="suboption.value">{{suboption.label}}</a-select-option>
                                </a-select-opt-group>
                                <a-select-option :value="option.value" v-if="!(option.options)" :key="oindex">{{option.label}}</a-select-option>
                            </template>
                        </a-select>
                        <a-cascader :options="searcher.options" v-if="searcher.type == 'cascader'" :defaultValue="searcher.val" v-model="vals[searcher_index][index]" @change="validations[searcher_index][index]={status:'success', help:null}"/>
                        <a-textarea autosize style="width:210px" :placeholder="searcher.placeholder" v-if="searcher.type == 'input'" :defaultValue="searcher.val" v-model="vals[searcher_index][index]" @change="validations[searcher_index][index]={status:'success', help:null}"/>
                        <Server v-if="searcher.type == 'server'" v-model="vals[searcher_index][index]"  pos="left"
                            :placeholder="searcher.placeholder" :label="searcher.label" :defaultValue="searcher.val" :single="searcher.single"
                            @change="validations[searcher_index][index]={status:'success', help:null}"/>
                    </a-form-item>
                </a-form>
                <template v-for="(searcher, index) in searchers[searcher_index]">
                    <ServerList v-model="vals[searcher_index][index]" :key="index" v-if="searcher.type=='server'&& searcher.single!=true"/>
                </template>
            </a-col>
        </a-row>
        <a-row style="text-align:right;">
            <div style="display:inline-block; text-align:right;">
                <a-form-item>
                    <a-button type="primary" html-type="submit" @click="submit">查询</a-button>
                    <a-button :style="{ marginLeft: '8px' }" @click="reset">重置</a-button>
                </a-form-item>
            </div>
        </a-row>
    </div>
</template>  

<script>
import {Form, DatePicker, Radio, Select, Input, Checkbox, Cascader} from 'ant-design-vue';
import Vue from 'vue'
Vue.use(Form)
Vue.use(DatePicker)
Vue.use(Radio)
Vue.use(Select)
Vue.use(Input)
Vue.use(Checkbox)
Vue.use(Cascader)

import Server from '@/components/common/search/server.vue'
import moment from 'moment'

import serverVue from './server.vue'
export default {
    props: ['items'],
    components: {
        Server,
    },
    mounted() {
        this.initSearcher()
    },
    watch: {
        items() {
            this.initSearcher()
        }
    },
    data() {
        return {
            searchers: [[],[]],
            vals:[[],[]],
            validations:[[],[]],
        }
    },
    methods: {
        initSearcher() {
            this.searchers = [_.cloneDeep(this.items), _.cloneDeep(this.items)]
            this.searchers[0].forEach((searcher)=>{
                if(searcher.type=='select' && searcher.multiple==true) {
                    let all = []
                    searcher.options.forEach((option)=>{
                        if(option.options) {
                            option.options.forEach((sub)=>{
                                all.push(sub.value)
                            })
                        } else {
                            all.push(option.value)
                        }
                    })
                    searcher.allvalue = all
                }
            })
            
            this.searchers[1].forEach((searcher)=>{
                if(searcher.type=='select' && searcher.multiple==true) {
                    let all = []
                    searcher.options.forEach((option)=>{
                        if(option.options) {
                            option.options.forEach((sub)=>{
                                all.push(sub.value)
                            })
                        } else {
                            all.push(option.value)
                        }
                    })
                    searcher.allvalue = all
                }
            })
            this.reset()
        },
        selectAll(searcher_index,index, e) {
            if(e.target.checked==true) {
                this.vals[searcher_index].splice(index, 1, this.searchers[index].allvalue)
            }
            else {
                this.vals[searcher_index].splice(index, 1, [])
            }
        },
        getDate(val) {
            if(typeof(val) == 'number') {
                if(val > 0) {
                    return moment(new Date()).add(val, 'days')
                } else if (val < 0){
                    return moment(new Date()).subtract(-val, 'days')
                } else {
                    return moment(new Date())
                }
            }
            else if(typeof(val) == 'string') {
                return moment(val)
            }
            else {
                return moment(new Date()).subtract(1, 'days')
            }
        },
        getMonth(val) {
            if(typeof(val) == 'number') {
                if(val > 0) {
                    return moment(new Date()).add(val, 'months')
                } else if (val < 0){
                    return moment(new Date()).subtract(-val, 'months')
                } else {
                    return moment(new Date())
                }
            }
            else if(typeof(val) == 'string') {
                return moment(val)
            }
            else {
                return moment(new Date())
            }
        },
        reset() {
            let vals = [], validations=[]
            this.items.forEach((searcher) => {
                validations.push({'status':'success', 'help':null})
                if(searcher.type == 'date') {
                    searcher.val = this.getDate(searcher.default)
                }
                else if(searcher.type == 'month') {
                    searcher.val = this.getMonth(searcher.default)
                }
                else if(searcher.type == 'daterange') {
                    if(searcher.default instanceof Array) {
                        searcher.val = [this.getDate(searcher.default[0]), this.getDate(searcher.default[1])]
                    }
                    else {
                        searcher.val = [this.getDate(null), this.getDate(null)]
                    }
                } 
                else {
                    searcher.val = searcher.default
                }
                vals.push(searcher.val)
            })
            this.vals = [vals, _.cloneDeep(vals)]
            this.validations = [validations, _.cloneDeep(validations)]
        },
        submit() {
            let all_params=[], all_required=[]
            for(let searcher_index=0; searcher_index<2; searcher_index++) {
                let params = {}, required=false
                this.searchers[searcher_index].forEach((searcher, index) => {
                    let value = this.vals[searcher_index][index]
                    if((value==null || value==undefined) || (searcher.type=='input' && value==='') || ((searcher.type=='checkbox' || (searcher.type=='select' && searcher.multiple)) && value.length==0)) {
                        if(searcher.required == true) {
                            this.validations[searcher_index].splice(index, 1 , {'status':'error', 'help': this.$t("pageHeader.mustFill")})
                            required = true
                        }
                        if(searcher.type=='server') {
                            params[searcher.id] = searcher.all?searcher.all: ''
                        }
                    }
                    else {
                        if(searcher.type == 'date') {
                            params[searcher.id] = value.format('YYYY-MM-DD')
                        }
                        else if(searcher.type == 'month') {
                            params[searcher.id] = value.format('YYYY-MM')
                        }
                        else if(searcher.type == 'daterange') {
                            params[`start_${searcher.id}`] = value[0].format('YYYY-MM-DD')
                            params[`end_${searcher.id}`] = value[1].format('YYYY-MM-DD')
                        }
                        else if(searcher.type == 'checkbox') {
                            if(!searcher.str) {
                                params[searcher.id] = _.join(value, ',')
                            } 
                            else  {
                                let val = _.join(value, "','")
                                if(val != '')
                                    val = `'${val}'`
                                params[searcher.id] = val
                            }
                        }
                        else if(searcher.type == 'select' && searcher.multiple==true) {
                            params[searcher.id] = _.join(value, ',')
                        }
                        else if(searcher.type == 'cascader') {
                            params[searcher.id] = _.join(value, ',')
                        }
                        else if(searcher.type == 'server') {
                            if(searcher.single==true) {
                                params[searcher.id] = value
                            }
                            else {
                                params[searcher.id] = _.join(value, ',')
                                let val = _.join(value, ",")
                                if(val == '' && searcher.all)
                                    val = searcher.all
                                params[searcher.id] = val
                            }
                        }
                        else {
                            params[searcher.id] = value
                        }
                    }
                    if(params[searcher.id]!=null && params[searcher.id]!=undefined) {
                        if(searcher.default_type == 'string') {
                            params[searcher.id] = params[searcher.id].toString()
                        } 
                        else if(searcher.default_type == 'number') {
                            params[searcher.id] = Number(params[searcher.id])
                            let newVal = Number(params[searcher.id])
                            if((newVal==null || newVal==undefined || isNaN(newVal)) && searcher.type=='input') {
                                error = true
                                this.validations[searcher_index].splice(index, 1 , {'status':'error', 'help':'请填写数字'})
                            }
                            else {
                                params[searcher.id] = newVal
                            }
                        }
                        if(searcher.prefix || searcher.suffix) {
                            params[searcher.id] = `${searcher.prefix?searcher.prefix:''}${params[searcher.id]}${searcher.suffix?searcher.suffix:''}`
                        }
                    }
                })
                all_params.push(params)
                all_required.push(required)
            }
            if(all_required[0]==true || all_required[1]==true) {
                return
            }
            this.$emit('search', all_params)
        }
    },
}
</script>

<style lang="less">
.page_search {
    .page_search_col {
        padding:0 0 0 20px;
        float:left;
        h3 {
            font-weight:bold;
        }
    }
    .page_search_col:nth-child(1) {
        padding:0 20px 0 0;
        border-right:1px solid #ddd;
    }
    .page_search_col:nth-child(2) {
        border-left:1px solid #ddd;
        margin:0 0 0 -1px;
    }
    // .ant-form-item-label {
    //     text-align: left;
    // }
    // .ant-form-item {min-width:200px;
    //     margin:10px 20px 0 0 ;
    //     label {
    //         display:inline-block;
    //         min-width:85px;
    //     }
    // }
}
</style>